/** @internal */
export const cacheControlSymbol = Symbol('cache-parser');
